export default {
        // Your original product data
        googleTV: {
          name: 'Q4', // Display name for the button
          faqs: [
            {
    "question": "Camera does not work properly.",
    "answer": "1, Confirm whether the installation operation is correct;<br\>2, Check whether the Wi-Fi status is good, you can restart the router;<br\>3, Move the device away from interference sources and find a location with good signal to reconnect."
  },
  {
    "question": "Memory Card cannot be recognized.",
    "answer": `1, Make sure the device is turned off before inserting the Micro SD card;<br\>2, Check if the card is formatted in FAT32 or exFAT format;<br\>3, Check if the memory card is corrupted.`
  },
  {
    "question": "Camera or Wi-Fi connection problems.",
    "answer": "1, Make sure the Wi-Fi name (SSID) and password are entered correctly;<br\>2, If the connection fails, follow the connection steps to set up again;<br\>3, Make sure the Wi-Fi signal is stable."
  },
  {
    "question": "Motion detection problems.",
    "answer": "1, For outdoor cameras, detection may be affected by vehicles, insects, leaves, and animals;<br\>2, Click APP > Camera Page > Settings > Motion Detection > Humanoid Detection Sensitivity;<br\>3, When false alarms are frequent, increase the sensitivity; when alarms are missed, decrease the sensitivity."
  },
  {
    "question": "Using multiple cameras at the same time.",
    "answer": "1, One account can connect multiple cameras;<br\>2, The maximum number depends on the APP regulations;<br\>3, Make sure each camera is set up correctly."
  },
  {
    "question": "Camera won't turn on.",
    "answer": "1, Check if the battery is properly installed or the power adapter is connected;<br\>2, If the problem persists, contact customer service."
  },
  {
    "question": "Delete photos.",
    "answer": "1, Open APP > Me > Album;<br\>2, Long press the photo you want to delete and tap \"Delete\"."
  },
  {
    "question": "The video sound is too low.",
    "answer": "1, Enter the camera page in the APP;<br\>2, Go to Settings > Sound Settings;<br\>3, Manually adjust the Speaker Volume."
  },
  {
    "question": "Motion recordings are not saved.",
    "answer": "1, Enter the camera page in the APP;<br\>2, Go to Settings > Recording Management > SD Card Capacity;<br\>3, Check whether the SD card is full or has errors."
  },
  {
    "question": "Change Wi-Fi connection.",
    "answer": "1, Long press the reset button to re-set up the Wi-Fi connection."
  },
  {
    "question": "Check the battery level.",
    "answer": "1, The approximate battery level is shown in the camera preview;<br\>2, For exact percentage, go to Settings > Battery Management."
  },
  {
    "question": "No notifications received.",
    "answer": "1, Check whether APP notifications are enabled;<br\>2, Check the mobile phone notification settings;<br\>3, Restart the camera if necessary;<br\>4, For Android: allow the APP to run in the background;<br\>5, If still not working, re-add the camera or adjust Wi-Fi orientation;<br\>6, If needed, uninstall and reinstall the APP."
  },
  {
    "question": "Battery consumption is too high.",
    "answer": "1, Frequent alarms may drain the battery quickly;<br\>2, Reduce unnecessary alarm settings;<br\>3, Reduce detection sensitivity;<br\>4, Limit the number of camera views;<br\>5, Avoid direct sunlight or high temperatures."
  },
  {
    "question": "Power supply problems.",
    "answer": "1, Only charge the device indoors and avoid extreme temperatures;<br\>2, If the device does not turn on, press and hold the power button for 5 seconds;<br\>3, If the problem persists, contact customer service."
  },
  {
    "question": "Charging problems.",
    "answer": "1, Check whether the charging cable is properly connected;<br\>2, Try a different charging cable and power adapter;<br\>3, If the problem persists, the battery may be defective—please contact customer service."
  }
]

          
        },
     
      }